import { httpBatchLink, httpLink, TRPCClientError } from "@trpc/client"
import { createTRPCReact } from "@trpc/react-query"

import trpcTransformer from "@forento/core/utilities/trpcTransformer"

import type { BokaderoRoutes } from "../../../api/src/routes"

export const query = createTRPCReact<BokaderoRoutes>({ abortOnUnmount: true })

const trpc = query.createClient({
	links: [
		CONFIG.isDevelopment
			? httpLink({ url: CONFIG.apiUrl, transformer: trpcTransformer })
			: httpBatchLink({
					url: CONFIG.apiUrl,
					transformer: trpcTransformer,
					fetch(url, options) {
						return fetch(url, { ...options, credentials: "include" })
					},
				}),
	],
})

function isTRPCClientError(cause: unknown): cause is TRPCClientError<BokaderoRoutes> {
	return cause instanceof TRPCClientError
}

export function getInputErrors(error: unknown): Record<string, string[]> {
	if (!isTRPCClientError(error)) return {}
	return error.data?.inputErrors ?? {}
}

export default trpc
